import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Table } from "reactstrap";
import { v4 as uuidv4 } from 'uuid'

import { confirm } from "components/Confirmation";
import FormPreposto from "./Form";
import IconButton from "components/IconButton";
import empresaService from "services/EmpresaService";

export default function Prepostos({ edit, idEmpresa }) {
  const [items, setItems] = useState([])

  const carregar = async () => {
    const res = await empresaService.getPreposto(idEmpresa)
    if (res.success) {
      setItems(res.data)
    }
  }

  useEffect(() => {
    if (idEmpresa) {
      carregar()
    }
  }, [idEmpresa])

  const handleAdicionar = async (data) => {
    try {
      const res = await empresaService.createPreposto(idEmpresa, data)
      if (res.success) {
        carregar()
        toast("Preposto cadastrado")
      } else {
        toast("Erro ao cadastrar preposto")
      }
    } catch (ex) {
      toast("Erro ao cadastrar preposto")
    }
  }

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await empresaService.deletePreposto(idEmpresa, item.id)
          if (res.success) {
            carregar()
            toast("Preposto excluído")
          } else {
            toast("Erro ao excluir o preposto")
          }
        } catch (ex) {
          toast("Erro ao excluir o preposto")
        }
      }
    })
  }

  return (
    <>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">E-mail</th>
            <th scope="col">Telefone</th>
            {edit && (
              <th scope="col" style={{ width: 60 }}></th>
            )}
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={4} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.map(el => (
            <tr key={el.id}>
              <td>{el.nome}</td>
              <td>{el.email}</td>
              <td>{el.telefone}</td>
              {edit && (
                <td className="d-flex flex-row gap-5px">
                  <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>

      {edit && (
        <FormPreposto onAdd={handleAdicionar} />
      )}
    </>
  )
}